// extracted by mini-css-extract-plugin
module.exports = {"container":"founder_container__F6c_m","avatar":"founder_avatar__Z89YC"};